// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_BORDER_RADIUS_NONE = '0px';
export const SYS_BORDER_RADIUS_XS = '4px';
export const SYS_BORDER_RADIUS_SM = '10px';
export const SYS_BORDER_RADIUS_MD = '20px';
export const SYS_BORDER_RADIUS_MAX = '999px';
//# sourceMappingURL=border-radius.generated.js.map